import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreditRuleService } from 'src/app/core/services/credit-rule.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import swal from 'sweetalert2';
import { Plan } from '../../../core/models/personalInfo';
import { User } from '../../../core/models/user';
import { AccountService } from '../../../core/services/account.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { SignalRService } from 'src/app/core/services/signalr.service';
import { memoryUsage } from 'process';

@Component({
    selector: 'app-documents-upload-qr-code',
    templateUrl: './documents-upload-qr-code.component.html',
    styleUrls: ['./documents-upload-qr-code.component.scss'],
})
export class DocumentsUploadQRCodeComponent implements OnInit {

    public href: string = '';

    public travelPlan: string = '';

    public FirstName: string = '';

    public Mobile: string = '';

    public Email: string = '';

    public PAN: string = '';

    public DOB: string = '';

    public Address: string = '';

    public DocsRequired: string = '';

    public Downpayment!: number;

    public EmiAmount!: number;

    public partnerTransactionId: string = '';

    public partnerCallbackUrl: string = '';

    public Loanamount!: number;

    public FirstEMIDueDate: string = '';

    public NumberOfTotalEMI!: number;

    public planDet!: Plan;

    public showApplication: boolean = false;

    public showDocsRequired: boolean = true;

    public btnProceed: string = '';

    public ProcessingFee!: number;

    public PayToday!: number;

    public hideEMI: boolean;

    public origin: string = '';

    public destination: string = '';

    public creditScore: number = 0;

    public travelDate: string = '';

    public emiTableData = {
        Downpayment: 0,
        EmiAmount: 0,
        Loanamount: 0,
        NumberOfTotalEMI: 0,
        ProcessingFee: 0,
        FirstEMIDueDate: ''
    }

    @Output()
    public selectedPlan = new EventEmitter();

    constructor(
        private route: ActivatedRoute,
        private accountService: AccountService,
        private creditRuleService: CreditRuleService,
        private spinner: NgxSpinnerService,
        private router: Router,
        private sessionTimerService: SessionTimerService,
        private signalRService: SignalRService
    ) {
        MemoryStorageService.removeItem('user');
        MemoryStorageService.removeItem('finalplan');
        this.hideEMI = MemoryStorageService.getItem("userSource") === 'LANDING_PAGE' || MemoryStorageService.getItem("userSource") === 'LANDING_PAGE_WIDGET';
    }

    public ngOnInit(): void {
        this.spinner.hide();
        MemoryStorageService.removeItem('OrderId');

        this.route.queryParams.subscribe((params) => {
            // console.log(params);
            this.travelPlan = params.travelplan;
            if (params.orderid) {
                MemoryStorageService.setItem('OrderId', params.orderid)
            }
            try {
                this.spinner.show();
                this.accountService.GetTravelPlan(this.travelPlan).subscribe(
                    (resp) => {
                        this.spinner.hide();
                        const response = resp['data'];
                        if (response != null) {
                            if (response.status == 'EXPIRED') {
                                this.showApplication = false;
                                var user: User = {
                                    userName: response.email,
                                    email: response.email,
                                    mobileNumber: response.mobileNumber,
                                    token: response.token,
                                    showFooter: false,
                                };
                                this.accountService.setCurrentUser(user);
                                MemoryStorageService.setItem('user', JSON.stringify(user));
                                swal.fire('The Plan is expired. Please try again');
                                this.spinner.hide();
                                this.router.navigateByUrl('/sorry');
                            } else if (response.status == 'INVALID') {
                                this.showApplication = false;
                                // var user: User = {
                                //   userName : response.email,
                                //   email: response.email,
                                //   mobileNumber: response.mobileNumber,
                                //   token: response.token,
                                //   showFooter:true
                                // };
                                // MemoryStorageService.setItem('user', JSON.stringify(user));
                                swal.fire('The selected plan is not valid anymore!');
                                this.spinner.hide();
                                this.router.navigateByUrl('/sorry');
                            } else {

                                MemoryStorageService.setItem('customerToken', response.token);
                                if (this.travelPlan.split('/').length < 2) {
                                    this.spinner.hide();
                                    this.router.navigateByUrl('/assist-journey/lender-selection');
                                }

                                this.spinner.hide();

                                this.showApplication = true;
                                this.btnProceed =
                                    response.ckycPan && response.ckycAadhaar
                                        ? 'Activate My Credit Line'
                                        : 'Upload document';
                                this.FirstName = response.firstname + ' ' + response.lastName;
                                this.Mobile = '+91' + response.mobileNumber;
                                this.Email = response.email;
                                this.PAN = response.pan;
                                this.DOB = moment(response.dob).format('DD-MMM-YYYY'); //response.dob.substring(0, 10);
                                this.Address = response.address;
                                this.destination = response.destination;
                                this.origin = response.origin;
                                this.creditScore = response.creditScore;
                                this.travelDate = response.traveldate;
                                if (response.requiredDocuments === "Repeat") {
                                    this.DocsRequired = '';
                                    this.showDocsRequired = false;
                                }
                                else if (JSON.parse(response.requiredDocuments).bankStatement) {
                                    if (response.ckycPan && response.ckycAadhaar) {
                                        this.DocsRequired = 'Bank Statement';
                                    } else if (response.ckycPan && !response.ckycAadhaar) {
                                        this.DocsRequired = 'Aadhaar & Bank Statement';
                                    } else if (!response.ckycPan && response.ckycAadhaar) {
                                        this.DocsRequired = 'PAN & Bank Statement';
                                    } else {
                                        this.DocsRequired = 'PAN, Aadhaar & Bank Statement';
                                    }
                                } else {
                                    if (response.ckycPan && response.ckycAadhaar) {
                                        this.DocsRequired = '';
                                        this.showDocsRequired = false;
                                    } else if (response.ckycPan && !response.ckycAadhaar) {
                                        this.DocsRequired = 'Aadhaar';
                                    } else if (!response.ckycPan && response.ckycAadhaar) {
                                        this.DocsRequired = 'PAN';
                                    } else {
                                        this.DocsRequired = 'PAN & Aadhaar';
                                    }
                                }
                                // this.DocsRequired = JSON.parse(response.requiredDocuments)
                                //   .bankStatement
                                //   ? 'PAN, Aadhaar & Bank Statement'
                                //   : 'PAN & Aadhaar';
                                this.Downpayment = response.plan.downpayment!;
                                this.EmiAmount = response.plan.emi_amount!;
                                this.Loanamount = response.plan.loan_amount!;
                                this.emiTableData.Downpayment = response.plan.downpayment!;
                                this.emiTableData.EmiAmount = response.plan.emi_amount!;
                                this.emiTableData.Loanamount = response.plan.loan_amount!;
                                MemoryStorageService.setItem("loanAmount", response.plan.loan_amount!);
                                MemoryStorageService.setItem('userSource', response.userSource);
                                this.hideEMI = response.userSource === 'LANDING_PAGE' || response.userSource === 'LANDING_PAGE_WIDGET';
                                this.FirstEMIDueDate = moment(response.plan.emi_date).format(
                                    'DD-MMM-YYYY'
                                ); // response.plan.emi_date!.substring(0, 10);
                                this.emiTableData.FirstEMIDueDate = moment(response.plan.emi_date).format(
                                    'DD-MMM-YYYY'
                                );
                                this.NumberOfTotalEMI = response.plan.tenor!;
                                this.emiTableData.NumberOfTotalEMI = response.plan.tenor!
                                this.ProcessingFee =
                                    response.plan.processing_fee! + response.plan.gst!;
                                this.emiTableData.ProcessingFee = response.plan.processing_fee! + response.plan.gst!;
                                this.PayToday = this.Downpayment + this.ProcessingFee;
                                this.FirstEMIDueDate = this.FirstEMIDueDate;
                                this.partnerTransactionId = response.partnerTransactionId;
                                MemoryStorageService.setItem("partnerTransactionId", this.partnerTransactionId);
                                this.partnerCallbackUrl = response.partnerCallbackUrl;
                                var user: User = {
                                    userName: response.email,
                                    email: response.email,
                                    mobileNumber: response.mobileNumber,
                                    token: response.token,
                                    docs: [
                                        {
                                            bankstatement: response.requiredDocuments === "Repeat" ? false : (JSON.parse(response.requiredDocuments)
                                                .bankStatement
                                                ? true
                                                : false),
                                        },
                                    ],
                                    emiamount: Number(this.EmiAmount),
                                    collectionAmount: Number(this.Loanamount),
                                    fullname: response.firstname + ' ' + response.lastName,
                                    firstCollectionDate: this.FirstEMIDueDate,
                                    showFooter: true,
                                };

                                this.accountService.setCurrentUser(user);
                                // if (response.userSource !== 'LANDING_PAGE' && response.userSource !== 'LANDING_PAGE_WIDGET') {
                                //     this.signalRService.initSignalR(user.token);
                                // }

                                MemoryStorageService.setItem('user', JSON.stringify(user));
                                MemoryStorageService.setItem('finalplan', JSON.stringify(response.plan));
                                localStorage.setItem('partnercallback', this.partnerCallbackUrl);
                            }
                        }
                        else {
                            this.spinner.hide();
                            this.router.navigateByUrl('/assist-journey/session-expired');
                        }
                    },
                    (error) => {
                        this.spinner.hide();
                        if (error.errors != null || error.errors != undefined) {
                            this.router.navigateByUrl('/assist-journey/session-expired');
                        }
                    }
                );
            } catch (e) {
                this.router.navigateByUrl('/assist-journey/session-expired');
            }
            this.spinner.hide();
        });
    }

    public ProceedToDocUpload() {
        this.router.navigateByUrl('/assist-journey/identity-proof');
    }

    // notifyHost() {
    //   window.opener.postMessage('Message from new window');
    // }
}
